import React from "react";
import "./maintenancePage.scss"; // Create a CSS file for styles
import logo from '../../asserts/images/napid.png';

const MaintenancePage = () => {
  return (
    <div className="maintenance-container">
         <img src={logo} alt="Logo" className="logo-image" />
      <h1 className="maintenance-text">
        We are Under Maintenance.
        <br />
        Will be Back Soon!
      </h1>
     
    </div>
  );
};

export default MaintenancePage;
